<bs-digital-pick-list>
    @for (betBuilderPick of picks; track betBuilderPick.id.toString()) {
        <bs-linear-bet-builder-pick
            [pick]="betBuilderPick"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [removeButtonStyle]="removeButtonStyle"></bs-linear-bet-builder-pick>
    }
</bs-digital-pick-list>
